/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SsoimageStatusesQueryResponse,
  GetApiV1SsoimageStatuses401,
  GetApiV1SsoimageStatuses500,
} from "../../types/SSOImageController/GetApiV1SsoimageStatuses.ts";

function getGetApiV1SsoimageStatusesUrl() {
  const res = { method: "GET", url: `/api/v1/ssoimage/statuses` as const };
  return res;
}

/**
 * @description Retorna todos os valores do enum ESSOImageStatus com id e nome. **(Requer Authorization para autenticação)**
 * @summary Buscar status de imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/statuses}
 */
export async function getApiV1SsoimageStatuses(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SsoimageStatusesQueryResponse,
    ResponseErrorConfig<
      GetApiV1SsoimageStatuses401 | GetApiV1SsoimageStatuses500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SsoimageStatusesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
